import React from "react";
import TicketWidget from "./TicketWidget";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";

const TicketOverviewDashboard = ({ data, widget_index }) => {
  if (data?.widget_id === "tickets_overview_1" && data?.graphData?.data) {
    return (
      <TicketWidget
        name="Current Duration Ticket Summary"
        description="The stats give an overview of tickets created during the selected duration and their status."
        data={data?.graphData}
        graph_type={data?.graph_type}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        ticket_chart_type={data?.graphData?.chart_type}
      />
    );
  } else if (
    data?.widget_id === "tickets_overview_2" &&
    data?.graphData?.data
  ) {
    return (
      <TicketWidget
        name="Role Wise Ticket Summary"
        description=""
        graph_type={data?.graph_type}
        data={data?.graphData?.data}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        ticket_chart_type={data?.graphData?.chart_type}
      />
    );
  } else if (
    data?.widget_id === "tickets_overview_3" &&
    data?.graphData?.number_data
  ) {
    return (
      <TicketWidget
        name="Pending - priority wise"
        description=""
        graph_type={data?.graph_type}
        data={data?.graphData?.number_data}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
        ticket_chart_type={data?.graphData?.chart_type}
      />
    );
  } else if (
    data?.widget_id === "tickets_overview_4" &&
    data?.graphData?.data
  ) {
    return (
      <TicketWidget
        name="Channel wise tickets"
        description=""
        graph_type={data?.graph_type}
        data={data?.graphData}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
        ticket_chart_type={data?.graphData?.chart_type}
      />
    );
  } else if (
    data?.widget_id === "tickets_overview_5" &&
    data?.graphData?.data
  ) {
    return (
      <TicketWidget
        name="Tickets assignment summary (Agents)"
        description="The stats shown below shows the summary of tickets assigned to agents  during the
        selected duration."
        graph_type={data?.graph_type}
        data={data?.graphData?.data}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
      />
    );
  } else if (
    data?.widget_id === "tickets_overview_6" &&
    data?.graphData?.data
  ) {
    return (
      <TicketWidget
        name="Tickets assignment summary (CSD/Brand)"
        description="
                    The stats shown below shows the summary of tickets assigned to agents  during the
                    selected duration."
        graph_type={data?.graph_type}
        data={data?.graphData?.data}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
      />
    );
  } else if (data?.widget_id === "tickets_overview_7" && data?.graphData) {
    return (
      <TicketWidget
        name="Current Ticket Assignment Status"
        description="The table below shows the current status all tickets assigned to agents in the selected duration (irrespective of the ticket created date)."
        graph_type={data?.graph_type}
        data={data?.graphData}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
      />
    );
  } else if (
    data?.widget_id === "tickets_overview_8" &&
    data?.graphData?.data
  ) {
    return (
      <TicketWidget
        name="Ticket Status Summary"
        description="This shows a trend wise distribution of all status of all the tickets received by your brand."
        graph_type={data?.graph_type}
        data={data?.graphData?.data}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
        ticket_chart_type={data?.graphData?.chart_type}
      />
    );
  } else if (data?.widget_id === "tickets_overview_9" && data?.graphData) {
    return (
      <TicketWidget
        name="Agent Ticket Status"
        description="The table below shows the current status all tickets assigned to agents in the selected duration (irrespective of the ticket created date)."
        graph_type={data?.graph_type}
        data={data?.graphData}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
      />
    );
  } else if (data?.widget_id === "tickets_overview_10" && data?.graphData) {
    return (
      <TicketWidget
        name="CSD Ticket Status"
        description="The table below shows the current status all tickets assigned to CSD in the selected duration (irrespective of the ticket created date)."
        graph_type={data?.graph_type}
        data={data?.graphData}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
      />
    );
  } else if (data?.widget_id === "tickets_overview_11" && data?.graphData) {
    return (
      <TicketWidget
        name="Brand Ticket Status"
        description="This list shows the users associated with managing your brand and the entire summary of the tickets assigned to them"
        graph_type={data?.graph_type}
        data={data?.graphData}
        xAxis={data?.graphData?.x_label}
        yAxis={data?.graphData?.y_label}
        widget_id={data?.graphData?.widget_id}
        widget_index={widget_index}
      />
    );
  } else if (typeof data?.graphData === "string") {
    return (
      <div
        className="portlet1 d-flex align-items-center justify-content-center mb-15"
        style={{ minHeight: "31rem" }}
      >
        <div className="text-center">
          <img
            alt="no data"
            src={somethingWentWrong}
            style={{ maxWidth: "100%", minWidth: "20rem" }}
          />
          <p className="mt-15 mb-0 text_regular-gray">No Data Found</p>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="portlet1 d-flex align-items-center justify-content-center mb-15"
        style={{ minHeight: "31rem" }}
      >
        <div
          className="loader text-center w-100"
          style={{ height: "calc(100vh - 15.2rem)" }}
        >
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
};

export default TicketOverviewDashboard;
